import {
  GetAuthCertRes,
  PostAuthCertCallbackReq,
  PostAuthCertCallbackRes,
  PostAuthLoginResponse,
} from "models/Auth";
import request from "./core";

export const postAuthLogin = ({
  provider,
  code,
}: {
  provider: "kakao" | "google";
  code: string;
}) => {
  const isLocal = process.env.REACT_APP_ENV === "local";

  let path = `/auth/login/${provider}`;
  if (isLocal) path = path + "/local";
  return request.post<PostAuthLoginResponse>(`${path}?code=${code}`);
};

export const getAuthCert = (email: string) => {
  const isLocal = process.env.REACT_APP_ENV === "local";

  let path = "/auth/cert";
  if (isLocal) path = path + "/local";

  return request.get<GetAuthCertRes>(`${path}?email=${email}`);
};

export const postAuthCertCallback = (data: PostAuthCertCallbackReq) => {
  return request.post<PostAuthCertCallbackRes>("/auth/cert/callback", data);
};
